import styled from 'styled-components';
import { outlineGray, primaryColor } from '../../../../config/colors';
import { MANIFOLD_HEIGHT, TILE_HEIGHT, TILE_WIDTH } from '../consts';

export const Wrapper = styled.div`
  display: flex;
  background-color: white;
  width: fit-content;
`;

export const BigTile = styled.div`
  display: flex;
  outline: 1px solid ${outlineGray};
  :hover {
    cursor: pointer;
    outline: 2px solid ${primaryColor};
  }
`;

export const SmallTile = styled.div`
  width: ${TILE_WIDTH}px;
  height: ${({isManifold}) => `${isManifold ? MANIFOLD_HEIGHT : TILE_HEIGHT}px`};
  :not(:last-of-type) {
    border-right: 1px dotted ${outlineGray};
  }
`;
